module.exports = __webpack_public_path__ + "static/media/defi_pulse.6a33c4a7.svg";